/**
 * Every top-level path the app handles itself. A one-segment path that isn't
 * here may be a Partner brand's short link (risklo.io/vector). Kept in sync
 * with App.js by appPages.test.js.
 */
export const KNOWN_PAGES = new Set([
  'about', 'account', 'admin-ai', 'admin-alerts', 'admin-entities', 'admin-equity-strategies', 'admin-feedback',
  'admin-live-strategy', 'admin-logs', 'admin-metrics-history', 'admin-site-metrics', 'admin-nt8-webhook-mapping', 'admin-scenario-data',
  'admin-sheet-manager', 'admin-strategy-submission', 'admin-strategy-submission-review', 'admin-trade-watch',
  'admin-users', 'admin-vector-nt-mappings', 'apex-30-percent-rule', 'brand-onboarding', 'brand-settings',
  'brand-strategies', 'client-reporting', 'companies', 'concentration-risk', 'consistency-rules', 'contact',
  'dashboard', 'desktopAppGuide', 'drawdown-risk', 'faq', 'features', 'hedging-risk', 'help', 'home',
  'how-to-export-csv', 'how-we-calculate', 'login', 'my-results', 'portfolio-simulator', 'position-sizer',
  'pricing', 'privacy-policy', 'prop-firm-planner', 'rebalance', 'results', 'results-spreadsheet', 'risk-tools', 'security',
  'stop-planner', 'terms-and-conditions', 'trade-watcher', 'tutorials', 'updates', 'vector-capital',
  'vector-capital-plus',
  // Handled outside the page switch (redirects, embeds, sign-in links).
  'vector-dashboard', 'overview-test', 'vector-updates', 'embed', 'tutorial-login', 'b', 'symbol',
]);

/** A path that could be a brand short link: one segment, slug-shaped, not an app page. */
export function vanitySlugFromPage(page) {
  const p = String(page || '');
  if (!p || p.includes('/') || KNOWN_PAGES.has(p)) return null;
  return /^[a-z0-9][a-z0-9_-]{0,62}$/i.test(p) ? p.toLowerCase() : null;
}
